import { render, staticRenderFns } from "./locationwisereport.vue?vue&type=template&id=97c8c150&scoped=true&"
import script from "./locationwisereport.vue?vue&type=script&lang=js&"
export * from "./locationwisereport.vue?vue&type=script&lang=js&"
import style0 from "./locationwisereport.vue?vue&type=style&index=0&id=97c8c150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c8c150",
  null
  
)

export default component.exports